/**
 * @generated SignedSource<<eb0717185a0cf7bc432d6687262b14a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProfileRouteQuery$variables = {};
export type ProfileRouteQuery$data = {
  readonly viewer: {
    readonly id: string;
    readonly ticketingEmailSignature: string | null;
    readonly ticketingReplyToEmail: string | null;
  } | null;
};
export type ProfileRouteQuery = {
  variables: ProfileRouteQuery$variables;
  response: ProfileRouteQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticketingEmailSignature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticketingReplyToEmail",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileRouteQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileRouteQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0e8d31b10034f89105e45d36214e53ae",
    "id": null,
    "metadata": {},
    "name": "ProfileRouteQuery",
    "operationKind": "query",
    "text": "query ProfileRouteQuery {\n  viewer {\n    id\n    ticketingEmailSignature\n    ticketingReplyToEmail\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c30e167fece24044f4663bb32fe1eb0";

export default node;
